// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Cookies from 'js.cookie'
import './gems.js'

// Fancybox imports
import { Fancybox } from '@fancyapps/ui'
import '@fancyapps/ui/dist/fancybox/fancybox.css'

require('@rails/ujs').start()
require('@rails/activestorage').start()
require('channels')
require('jquery')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// React application entry point
require('../index.js')// Support component names relative to this directory:

var componentRequireContext = require.context('components', true)
var ReactRailsUJS = require('react_ujs')
ReactRailsUJS.useContext(componentRequireContext)
window.Cookies = Cookies

// Initialize Fancybox
// This will bind Fancybox to all elements with the data-fancybox attribute.
// You might need to adjust the selector and options based on your specific usage.
Fancybox.bind('[data-fancybox]', {
  // Your custom options go here
})
